<template>
  <div class="main-content">
    <div class="page-header">
      <h3 class="page-title">Cajas</h3>
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a>Home</a>
        </li>
        <li class="breadcrumb-item">
          <a>Cuentas</a>
        </li>
        <li class="breadcrumb-item active">Cajas</li>
      </ol>
    </div>
    <div class="card">
      <div class="card-header">
        <!-- <h6>Categoría</h6> -->
        <button type="button" class="btn btn-theme" @click="openModal('register', '')">Nuevo</button>
      </div>
      <div class="card-body">
        <!-- busqueda -->
        <div class="form-group row">
          <div class="col-md-6">
            <div class="input-group">
              <select v-model="critery" class="form-control col-md-6">
                <option value="name">Nombre de la caja</option>
                <option value="place">Localidad</option>
              </select>
              <input v-model="search" type="text" class="form-control" placeholder="Ingrese el texto a buscar" @keyup="fetchData(1,search,critery,cashState)">
              <button type="submit" class="btn btn-theme" @click="fetchData(1,search,critery, cashState)"><i class="icon-fa icon-fa-search"/> Buscar</button>
            </div>
            <br>
            <div class="custom-control custom-checkbox mb-3">
              <input
                id="customControlValidation1"
                v-model="cashState"
                type="checkbox"
                class="custom-control-input"
                required
                @change="fetchData(1, search, critery, cashState)"
              >
              <label v-if="cashState === false" class="custom-control-label" for="customControlValidation1">
                Mostrar datos inactivos
              </label>
              <label v-else class="custom-control-label" for="customControlValidation1">
                Mostrar datos activos
              </label>
              <div class="invalid-feedback">Example invalid feedback text</div>
            </div>
          </div>
        </div>
        <!-- tabla -->
        <table class="table table-responsive">
          <thead>
            <tr>
              <th>Nombre</th>
              <th>Descripción</th>
              <th>Encargado de caja</th>
              <th>Cantidad</th>
              <th>Localidad</th>
              <th>Pago que acepta</th>
              <th>Estado</th>
              <th>Fecha de registro</th>
              <th>Opciones</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="account in accountArray" :key="account.id">
              <td v-text="account.name"/>
              <td v-text="account.description"/>
              <td v-if="account.idemployee==null" v-text="'Sin encargado'"/>
              <td v-else v-text="account.cashier.person.name"/>
              <td v-text="formatQuetzales(account.amount)"/>
              <td v-text="mostrarArray(account.places)"/>
              <td v-text="mostrarArray(account.payments)"/>
              <td>
                <span v-if="account.state==1" class="btn btn-success btn-sm">Activo</span>
                <span v-else class="btn btn-danger btn-sm">Desactivado</span>
              </td>
              <td v-text="account.created_at"/>
              <td>
                <template>
                  <div class="btn-group mr-2"
                       role="group"
                       aria-label="First group">
                    <router-link v-tooltip.top-center="'Ver caja'" :to="`/admin/cuenta/ver?item=${account.id}`" class="btn btn-success btn-block"><i class="icon-fa icon-fa-eye"/></router-link>
                    <a/>
                    <button v-tooltip.top-center="'Edita caja'" class="btn btn-theme btn-block" @click="openModal('update', account)"><i class="icon-fa icon-fa-pencil"/></button>
                    <a/>
                    <!-- Preguntar si se deja editar y desactivar escrito o solo los iconos -->
                    <button v-tooltip.top-center="'Desactivar caja'" v-if="account.state==1" class="btn btn-danger btn-block" @click="openModal('deactivate', account)"><i class="icon-fa icon-fa-trash"/></button>
                    <button v-tooltip.top-center="'Activar caja'" v-else class="btn btn-info btn-block" @click="openModal('activate', account)"><i class="icon-fa icon-fa-check"/></button>
                  </div>
                </template>
              </td>
            </tr>
          </tbody>
        </table>

        <!--Paginación de tabla-->
        <div class="card">
          <div class="card-body">
            <ul class="pagination pagination-primary m-b-0">
              <li v-if="pagination.current_page > 1" class="page-item">
                <a class="page-link" href="#" @click.prevent="changePage(pagination.current_page - 1, search, critery, cashState)"><i class="icon-fa icon-fa-angle-left"/></a>
              </li>
              <li v-for="page in pagesNumber" :key="page" :class="[page == isActived ? 'active' : '']" class="page-item">
                <a class="page-link" href="#" @click.prevent="changePage(page, search, critery, cashState)" v-text="page"/>
              </li>
              <li v-if="pagination.current_page < pagination.last_page" class="page-item">
                <a class="page-link" href="#" @click.prevent="changePage(pagination.current_page + 1, search, critery, cashState)"><i class="icon-fa icon-fa-angle-right"/></a>
              </li>
            </ul>
          </div>
        </div>

      </div>
      <!-- MODALES -->
      <sweet-modal
        ref="modal_account"
        :title="modalTitle"
        hide-close-button
        blocking
      >
        <!-- START FORM -->
        <div class="card-body">
          <!-- Nombre -->
          <div class="form-group">
            <label>Nombre</label>
            <input
              :class="{ 'is-invalid': $v.name.$error }"
              v-model.trim="name"
              class="form-control"
              @input="$v.name.$touch()"
            >
            <div v-if="$v.name.$error">
              <span
                v-if="!$v.name.required"
                class="help-block help-block-error"
              >El campo es requerido</span>
            </div>
          </div>
          <!-- Descripcion -->
          <div class="form-group">
            <label>Descripción</label>
            <input
              :class="{ 'is-invalid': $v.description.$error }"
              v-model.trim="description"
              class="form-control"
              @input="$v.description.$touch()"
            >
            <div v-if="$v.description.$error">
              <span
                v-if="!$v.description.required"
                class="help-block help-block-error"
              >El campo es requerido</span>
            </div>
          </div>
          <!-- empleado -->
          <div class="form-group">
            <label>Encargado de caja</label>
            <multiselect
              v-model="employee_id"
              :options="arrayEmployees"
              :close-on-select="true"
              :clear-on-select="false"
              :loading="isLoadingAccounts"
              :show-labels="false"
              placeholder="Seleccione un empleado"
              label="name"
              track-by="id"
              @search-change="showEmployees"
            >
              <template slot="beforeList">
                <button class="btn btn-success btn-lg btn-block" @click="openModal('employee', '')">Nuevo empleado<i
                  class="icon-fa icon-fa-plus" /></button>
              </template>
            </multiselect>
          </div>
          <!-- amount -->
          <div v-if="typeAction==1" class="form-group">
            <label>Cantidad</label>
            <masked-input
              v-model="amount"
              :guide="false"
              :mask="mask_quetzal"
              :class="{ 'is-invalid': $v.amount.$error }"
              type="text"
              class="form-control"
              @input="$v.amount.$touch()"
            />
            <div v-if="$v.amount.$error">
              <span
                v-if="!$v.amount.required"
                class="help-block help-block-error"
              >El campo es requerido</span>
            </div>
          </div>
          <div v-else class="form-group">
            <label>Cantidad</label>
            <masked-input
              v-model="amount"
              :guide="false"
              :mask="mask_quetzal"
              :class="{ 'is-invalid': $v.amount.$error }"
              disabled
              type="text"
              class="form-control"
              @input="$v.amount.$touch()"
            />
            <div v-if="$v.amount.$error">
              <span
                v-if="!$v.amount.required"
                class="help-block help-block-error"
              >El campo es requerido</span>
            </div>
          </div>
          <!-- Payment -->
          <div class="form-group">
            <label>Tipo de pago que acepta la caja</label>

            <multiselect
              v-model="payment"
              :class="{ 'is-invalid': $v.payment.$error }"
              :options="paymentArray"
              :multiple="true"
              :close-on-select="false"
              :clear-on-select="false"
              :preserve-search="true"
              :show-labels="false"
              placeholder="Seleccione"
              label="name"
              track-by="id"
              disabled
            />
            <div v-if="$v.payment.$error">
              <span
                v-if="!$v.payment.required"
                class="error"
              >Seleccione una opción</span>
            </div>
          </div>

          <!-- Place -->
          <div class="form-group">
            <label>Localidad</label>

            <multiselect
              v-model="idplace"
              :class="{ 'is-invalid': $v.idplace.$error }"
              :options="placeArray"
              :close-on-select="true"
              :clear-on-select="false"
              :preserve-search="true"
              :show-labels="false"
              placeholder="Seleccione"
              label="name"
              track-by="id"
            />
            <div v-if="$v.idplace.$error">
              <span
                v-if="!$v.idplace.required"
                class="error"
              >Seleccione una opción</span>
            </div>

          </div>

        </div>
        <!-- END FORM -->
        <button slot="button" type="button" class="btn btn-danger" @click="closeModal()">Cancelar</button>
        <button
          v-if="typeAction == 1"
          slot="button"
          type="button"
          class="btn btn-primary ladda-button"
          data-style="expand-right"
          @click="saveAccount()"
        >Guardar</button>
        <button
          v-if="typeAction == 2"
          slot="button"
          type="button"
          class="btn btn-primary ladda-button"
          data-style="expand-right"
          @click="updateAccount()"
        >Actualizar</button>
      </sweet-modal>
      <sweet-modal
        ref="activate_modal"
        icon="info"
        hide-close-button
        blocking
      >
        {{ modalTitleActivate }}
        <button
          slot="button"
          type="button"
          class="btn btn-info"
          @click="$refs.activate_modal.close()"
        >No</button>
        <button
          v-if="typeAction == 3"
          slot="button"
          type="button"
          class="btn btn-danger"
          @click="deactivateAccount()"
        >Si</button>
        <button
          v-if="typeAction == 4"
          slot="button"
          type="button"
          class="btn btn-danger"
          @click="activateAccount()"
        >Si</button>
      </sweet-modal>

      <sweet-modal ref="employee_modal" :title="modalTitleEmployee" hide-close-button blocking>
        <sweet-modal-tab id="tab1" title="Datos principales">
          <div class="form-group">
            <label>Nombre</label>
            <input
              :class="{ 'is-invalid': $v.nameEmployee.$error }"
              v-model.trim="nameEmployee"
              class="form-control"
              placeholder="Ingrese el nombre del empleado"
              @keyup.39="$refs.employee_modal.open('tab2')"
              @input="$v.nameEmployee.$touch()"
            >
            <div v-if="$v.nameEmployee.$error">
              <span
                v-if="!$v.nameEmployee.required"
                class="help-block help-block-error"
              >El campo es requerido</span>
              <span v-if="!$v.nameEmployee.minLength" class="help-block help-block-error">
                El minimo del caracteres es de
                {{ $v.nameEmployee.$params.minLength.min }} letras.
              </span>
            </div>
          </div>
          <div class="form-group">
            <label>Direccion</label>
            <textarea
              v-model.trim="address"
              class="form-control"
              placeholder="Ingrese la dirección"
              @keyup.39="$refs.employee_modal.open('tab2')"
            />
          </div>
          <div class="form-group">
            <label>Genero</label>
            <select v-model.trim="gender" class="form-control">
              <option value="0">Seleccione el genero</option>
              <option value="1">Masculino</option>
              <option value="2">Femenino</option>
            </select>
          </div>
          <div class="form-group">
            <label>Número</label>
            <masked-input
              v-model.trim="number"
              :mask="[ /\d/,/\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]"
              class="form-control"
              placeholder="Ingrese el número de teléfono"
              @keyup.39="$refs.employee_modal.open('tab2')"
            />
          </div>
          <div class="form-group">
            <label>CUI</label>
            <masked-input
              v-model.trim="cui"
              :mask="[ /\d/,/\d/, /\d/, /\d/, ' ',/\d/, /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/]"
              class="form-control"
              placeholder="Ingrese el número de identificación personal"
              @keyup.39="$refs.employee_modal.open('tab2')"
            />
          </div>
        </sweet-modal-tab>
        <sweet-modal-tab id="tab2" title="Datos de trabajo">
          <div class="form-group">
            <label>Correo</label>
            <input
              v-model.trim="email"
              :class="{ 'is-invalid': $v.email.$error }"
              type="email"
              class="form-control"
              placeholder="Ingrese el correo electrónico"
              @input="$v.email.$touch()"
            >
            <div v-if="$v.email.$error">
              <span
                v-if="!$v.email.correo"
                class="help-block help-block-error"
              >El correo electrónico es invalido</span>
            </div>
          </div>
          <div class="form-group">
            <label>Trabajo</label>
            <input
              v-model.trim="job"
              class="form-control"
              placeholder="Ingrese el puesto de trabajo"
            >
          </div>
          <div class="form-group">
            <label>Lugar de trabajo</label>
            <select v-model.trim="idplaceEmployee" :class="{ 'is-invalid': $v.idplaceEmployee.$error }" class="form-control" @input="$v.idplaceEmployee.$touch()">
              <option
                v-for="place in placeArray"
                :key="place.id"
                :value="place.id"
                v-text="place.name"
              />
            </select>
            <div v-if="$v.idplaceEmployee.$error">
              <span
                v-if="!$v.idplaceEmployee.required"
                class="help-block help-block-error"
              >El lugar de trabajo es requerido</span>
            </div>
          </div>
          <div class="form-group">
            <label>Fecha de contratación</label>
            <datepicker
              :class="{ 'is-invalid': $v.hiring_date.$error }"
              :format="customFormatter" v-model.trim="hiring_date"
              :language="es"
              input-class="form-control"
              placeholder="Ingrese la fecha de contratación"
              @keyup.13="saveEmployee"
              @input="$v.hiring_date.$touch()" />
            <div v-if="$v.hiring_date.$error">
              <span
                v-if="!$v.hiring_date.required"
                class="help-block help-block-error"
              >La fecha de contratación es requerida</span>
            </div>
          </div>

        </sweet-modal-tab>
        <!-- Termina modal -->
        <!-- Botones -->
        <button slot="button" type="button" class="btn btn-danger" @click="$refs.employee_modal.close()">Cancelar</button>
        <button
          slot="button"
          type="button"
          class="btn btn-primary ladda-button"
          data-style="expand-right"
          @click="saveEmployee()"
        >Guardar</button>
      </sweet-modal>

    </div>
  </div>
</template>

<script>
import { SweetModal, SweetModalTab } from 'sweet-modal-vue'
import { required, minLength } from 'vuelidate/lib/validators'
import { Multiselect } from 'vue-multiselect'
import ladda from 'ladda'
import MaskedInput from 'vue-text-mask'
import createNumberMask from 'text-mask-addons/dist/createNumberMask'
import { es } from 'vuejs-datepicker/dist/locale'
import Datepicker from 'vuejs-datepicker'
import moment from 'moment'
import {xelacode} from '../../../helpers/xelacode'

let correo = (value) => xelacode.correo(value)

export default {
  components: {
    SweetModal,
    SweetModalTab,
    Multiselect,
    Datepicker,
    'masked-input': MaskedInput
  },
  data () {
    return {
      modalTitle: '',
      name: '',
      description: '',
      id: 0,
      amount: '',
      bank: '',
      idplace: null,
      payment: [{'id': 1, 'name': 'Efectivo'}, {'id': 2, 'name': 'Cheque'}],
      idTypeAccount: '',
      accountArray: [],
      placeArray: [],
      showPlacesArray: [],
      paymentArray: [],
      showPaymentsArray: [],
      typeAccountArray: [],
      transactionsArray: [],
      mask_quetzal: createNumberMask({
        prefix: 'Q ',
        suffix: '',
        includeThousandsSeparator: true,
        thousandsSeparatorSymbol: ',',
        allowDecimal: true,
        decimalSymbol: '.',
        decimalLimit: 2, // how many digits allowed after the decimal
        integerLimit: 10, // limit length of integer numbers
        allowNegative: false,
        allowLeadingZeroes: false
      }),
      typeAction: 1,
      modalTitleActivate: '',
      pagination: {
        'total': 0,
        'current_page': 0,
        'per_page': 0,
        'last_page': 0,
        'from': 0,
        'to': 0
      },
      offset: 3,
      critery: 'name',
      search: '',
      cashState: false,
      employee_id: [],
      arrayEmployees: [],
      isLoadingAccounts: false,
      // employee
      nameEmployee: '',
      address: '',
      number: '',
      email: '',
      cui: '',
      gender: 0,
      job: '',
      hiring_date: '',
      idplaceEmployee: null,
      modalTitleEmployee: 'Agregar nuevo empleado',
      es: es,
      format: 'yyyy-MM-dd'

    }
  },
  computed: {
    isActived: function () {
      return this.pagination.current_page
    },
    pagesNumber: function () {
      if (!this.pagination.to) {
        return []
      }
      var from = this.pagination.current_page - this.offset
      if (from < 1) {
        from = 1
      }
      var to = from + (this.offset * 2)
      if (to >= this.pagination.last_page) {
        to = this.pagination.last_page
      }
      var pagesArray = []
      while (from <= to) {
        pagesArray.push(from)
        from++
      }
      return pagesArray
    }
  },
  mounted () {
    this.fetchData(1, this.search, this.critery, this.cashState)
  },
  install (Vue, options) {
    Vue.component('SweetModal', SweetModal)
    Vue.component('SweetModalTab', SweetModalTab)
  },
  validations () {
    if (this.typeAction == 5) {
      return {
        name: {
        },
        description: {

        },
        amount: {

        },
        idplace: {

        },
        payment: {

        },
        hiring_date: {
          required
        },
        idplaceEmployee: {
          required
        },
        nameEmployee: {
          required,
          minLength: minLength(4)
        },
        email: {
          correo
        }
      }
    } else {
      return {
        name: {
          required,
          minLength: minLength(4)
        },
        description: {
          required
        },
        amount: {
          required
        },
        idplace: {
          required
        },
        payment: {
          required
        },
        hiring_date: {

        },
        idplaceEmployee: {

        },
        nameEmployee: {

        },
        email: {}
      }
    }
  },
  methods: {
    changePage (page, search, critery, state) {
      let me = this
      // Actualiza la página actual
      me.pagination.current_page = page
      // Envia la petición para visualizar la data de esa página
      me.fetchData(page, search, critery, state)
    },
    async fetchData (page, search, critery, state) {
      let me = this
      const response = await axios.get(
        `/api/admin/pettyCash/get?page=${page}&search=${search}&critery=${critery}&state=${state}`
      )
        .then(function (response) {
          var respuesta = response.data
          me.accountArray = respuesta.accounts.data
          me.fillShowPlacesArray()
          me.fillShowPaymentsArray()
          me.pagination = respuesta.pagination
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    saveAccount () {
      var l = ladda.create(document.querySelector('.ladda-button'))
      this.$v.$touch()
      let me = this
      if (this.$v.$invalid) {
        toastr.error('Revise los campos', 'Error')
      } else {
        l.start()
        axios
          .post('/api/admin/pettyCash', {
            name: this.name,
            description: this.description,
            amount: this.converMaskToNumber(),
            places: this.idplace,
            cashier: this.employee_id.id,
            payments: this.payment
            // bank: this.bank
          })
          .then(function (response) {
            toastr.success(response.data.message, 'Listo')
            l.stop()
            me.closeModal()
          })
          .catch(function (error) {
            l.stop()
            console.log(error)
            toastr.error(error.response.data.message, 'Error')
          })
      }
    },
    updateAccount () {
      var l = ladda.create(document.querySelector('.ladda-button'))
      this.$v.$touch()
      let me = this
      if (this.$v.$invalid) {
        toastr.error('Revise los campos', 'Error')
      } else {
        l.start()
        axios
          .put('/api/admin/pettyCash/update', {
            id: this.id,
            name: this.name,
            description: this.description,
            amount: this.converMaskToNumberxd(this.amount),
            cashier: this.employee_id.id,
            payments: this.payment,
            places: this.idplace
          })
          .then(function (response) {
            toastr.success(response.data.message, 'Listo')
            // console.log(response)
            l.stop()
            me.closeModal()
            // Aqui volver a listar todo
          })
          .catch(function (error) {
            l.stop()
            console.log(error)
            toastr.error(error.response.data.message, 'Error')
          })
      }
    },
    activateAccount () {
      let me = this
      axios
        .put('/api/admin/account/activate', {
          id: this.id
        })
        .then(function (response) {
          toastr.success(response.data.message, 'Listo')
          me.closeModal()
          // Aqui volver a listar todo
        })
        .catch(function (error) {
          toastr.error(error.response.data.message, 'Error')
        })
    },
    deactivateAccount () {
      let me = this
      axios
        .put('/api/admin/account/deactivate', {
          id: this.id
        })
        .then(function (response) {
          toastr.success(response.data.message, 'Listo')
          me.closeModal()
          // Aqui volver a listar todo
        })
        .catch(function (error) {
          toastr.error(error.response.data.message, 'Error')
        })
    },
    openModal (accion, data = []) {
      let me = this
      switch (accion) {
        case 'register': {
          this.selectPlace()
          this.selectPayment()
          me.$refs.modal_account.open()
          this.modalTitle = 'Nueva caja'
          this.name = ''
          this.typeAction = 1
          this.showEmployees('A')
          break
        }
        case 'update': {
          // console.log(data)
          this.selectPlace()
          this.selectPayment()
          me.$refs.modal_account.open()
          this.modalTitle = 'Actualizar caja'
          this.name = data['name']
          this.id = data['id']
          this.description = data['description']
          this.amount = this.formatQuetzales(data['amount'])
          this.idplace = data['idplace']
          this.bank = data['bank']
          this.payment = data['payments']
          this.idplace = data['places'][0]
          this.employee_id = {
            'id': data['idemployee'],
            'name': data['cashier']['person']['name']
          }
          this.typeAction = 2
          break
        }
        case 'deactivate': {
          me.$refs.activate_modal.open()
          this.modalTitleActivate = '¿Desea desactivar la caja?'
          this.id = data['id']
          this.typeAction = 3
          break
        }
        // eslint-disable-next-line no-fallthrough
        case 'activate': {
          me.$refs.activate_modal.open()
          this.modalTitleActivate = '¿Desea activar la caja?'
          this.id = data['id']
          this.typeAction = 4
          break
        }
        case 'see': {
          me.$router.push({name: 'verCuenta',
            params: {
              account: data
            }
          })
          break
        }
        case 'employee': {
          me.$refs.employee_modal.open()
          this.employee_id = null
          this.nameEmployee = ''
          this.address = ''
          this.number = ''
          this.email = ''
          this.cui = ''
          this.gender = 0
          this.job = ''
          this.hiring_date = ''
          this.idplace = 0
          this.typeAction = 5
          this.modalTitleEmployee = 'Agregar nuevo empleado'
          break
        }
      }
    },
    closeModal () {
      this.$v.$reset()
      this.$refs.modal_account.close()
      this.$refs.activate_modal.close()
      this.modalTitleActivate = ''
      this.name = ''
      this.description = ''
      this.amount = ''
      this.modalTitle = ''
      this.bank = ''
      this.idplace = null
      this.idTypeAccount = ''
      this.employee_id = []
      this.fetchData(this.pagination.current_page, this.search, this.critery, this.cashState)
    },
    selectPlace () {
      let me = this
      var url = '/api/admin/place/getSelect'
      axios
        .get(url)
        .then(function (response) {
          var respuesta = response.data
          me.placeArray = respuesta.place
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    selectPayment () {
      let me = this
      var url = '/api/admin/payment/getSelect'
      axios
        .get(url)
        .then(function (response) {
          // var respuesta = response.data
          me.paymentArray = response.data.payments
          // console.log(response)
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    showArray (array) {
      // console.log(places)

      return array
    },
    fillShowPlacesArray () {
      for (let i = 0; i < this.accountArray.length; i++) {
      // let placeArray = i.places
        this.showPlacesArray[i] = []
        for (let j = 0; j < this.accountArray[i].places.length; j++) {
          let name = this.accountArray[i].places[j].name
          this.showPlacesArray[i] = this.showPlacesArray[i].concat(name)
        }
      }
    },
    fillShowPaymentsArray () {
      for (let i = 0; i < this.accountArray.length; i++) {
      // let placeArray = i.places
        this.showPaymentsArray[i] = []
        for (let j = 0; j < this.accountArray[i].payments.length; j++) {
          let name = this.accountArray[i].payments[j].name
          this.showPaymentsArray[i] = this.showPaymentsArray[i].concat(name)
        }
      }
    },
    converMaskToNumber () {
      var myNumber = ''
      for (var i = 0; i < this.amount.length; i += 1) {
        if (this.amount.charAt(i) === 'Q' || this.amount.charAt(i) === ',' || this.amount.charAt(i) === ' ') {
          continue
        } else {
          myNumber += this.amount.charAt(i)
        }
      }
      return parseFloat(myNumber).toFixed(2)
    },
    converMaskToNumberxd (number) {
      var myNumber = ''
      for (var i = 0; i < number.length; i += 1) {
        if (number.charAt(i) === 'Q' || number.charAt(i) === ',' || number.charAt(i) === ' ') {
          continue
        } else {
          myNumber += number.charAt(i)
        }
      }
      return parseFloat(myNumber).toFixed(2)
    },
    mostrarArray (item) {
      var letra = ''
      item.forEach(element => {
        letra = letra + ', ' + element.name
        // letra += element.name + ''
      })
      letra = letra.substring(2, letra.length)
      return letra
    },
    formatQuetzales (amount) {
      var num = parseFloat(amount), formatted
      formatted =  num.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
      return amount = 'Q ' + formatted
    },
    showEmployees (filter) {
      let me = this
      var url = `/api/admin/employees/getSelect?filter=${filter}`
      this.isLoadingAccounts = true
      axios.get(url)
        .then(function (response) {
          me.arrayEmployees = response.data.data
          me.isLoadingAccounts = false
        })
        .catch(function (error) {
          me.isLoadingAccounts = false
          console.log(error)
        })
    },
    saveEmployee () {
      var l = ladda.create(document.querySelector('.ladda-button'))
      this.$v.$touch()
      this.$v.email.$touch()
      let me = this
      // console.log(this.name)
      if (this.$v.nameEmployee.$invalid || this.$v.hiring_date.$invalid || this.$v.idplaceEmployee.$invalid) {
        // eslint-disable-next-line no-undef
        toastr.error('Revise los campos', 'Error')
      } else {
        l.start()
        // eslint-disable-next-line no-undef
        axios
          .post('/api/admin/employees', {
            name: this.nameEmployee,
            address: this.address,
            number: this.number,
            email: this.email,
            cui: this.cui,
            gender: this.gender,
            job: this.job,
            hiring_date: this.customFormatter(this.hiring_date),
            idplace: this.idplaceEmployee
          })
          .then(function (response) {
            // eslint-disable-next-line no-undef
            toastr.success('Nuevo empleado agregado', 'Guardado')
            // console.log(response.data.id)
            l.stop()
            me.changeValueId(response.data.id, me.nameEmployee)
            me.$v.$reset()
          })
          // eslint-disable-next-line handle-callback-err
          .catch(function (error) {
            l.stop()
            // eslint-disable-next-line no-undef
            toastr.error(error.response.data.message, 'Error')
          })
      }
    },
    convertDate (str) {
      // eslint-disable-next-line one-var
      var date = new Date(str), mnth = ('0' + (date.getMonth() + 1)).slice(-2), day = ('0' + date.getDate()).slice(-2)
      this.hiring_date = [date.getFullYear(), mnth, day].join('-')
    },
    changeValueId (id, name) {
      // eslint-disable-next-line standard/object-curly-even-spacing
      this.employee_id = { 'id': `${id}`, 'name': `${name}`}
      this.$refs.employee_modal.close()
      this.typeAction = 1
      this.showEmployees('A')
    },
    customFormatter (date) {
      return moment(date).format('YYYY-MM-DD')
    }
  }
}
</script>
<style>
.error {
  color: #dc3545;
}
</style>



// WEBPACK FOOTER //
// resources/js/views/admin/account/PettyCash.vue